import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "../../box/src";
import { CATEGORIES, FontAwesomeIconWithBackground, } from "../../font-awesome-icon/src";
export const Icon = ({ iconStyle }) => (_jsx(Box, { mr: 4, children: _jsx(FontAwesomeIconWithBackground, { color: iconStyle.color, height: "35px", iconName: iconStyle.iconName, iconType: CATEGORIES.SOLID }) }));
//# sourceMappingURL=Icon.js.map